export default class NotificationMail{
    constructor({send=false,text=null}){
        this.send=send;
        this.text=text
    }
}